import { Ad } from "@component/Widget/Ad/Ad";
import RelatedNews from "@component/Widget/Article/RelatedNews";
import RssBlogs from "@component/Widget/Article/RssBlogs";
import type { ReactNode } from "react";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { LandingContainer } from "./LandingContainer";

interface Props {
	tags: string;
}

export class LandingBottom extends React.PureComponent<Props> {
	public render(): ReactNode {
		const { tags } = this.props;

		return (
			<LandingContainer>
				<div>
					<Ad name="640x360 TOP1" code="6365748" width="640" height="360" type="desktop" priority={40} />
				</div>
				<RelatedNews title="Kapcsolódó tartalmak" count={4} tags={tags.split(",")} />
				<Row>
					<Col lg={8}>
						<RssBlogs />
					</Col>
					<Col lg={4}>
						<Ad name="300x250 TOP1" code="5967600" width="300" height="250" type="desktop" priority={39} />
						<Ad name="300x250 TOP2" code="5967601" width="300" height="250" type="all" priority={38} />
					</Col>
				</Row>
			</LandingContainer>
		);
	}
}
